import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Unlock = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M11 12C11 7.02944 15.0294 3 20 3C23.9899 3 27.371 5.59565 28.5516 9.18775C28.7241 9.71242 28.4385 10.2775 27.9139 10.45C27.3892 10.6225 26.8241 10.3369 26.6516 9.81225C25.7327 7.01648 23.1005 5 20 5C16.134 5 13 8.13401 13 12V16H31C32.6569 16 34 17.3431 34 19V33C34 34.6569 32.6569 36 31 36H9C7.34315 36 6 34.6569 6 33V19C6 17.3431 7.34315 16 9 16H11V12ZM9 18C8.44772 18 8 18.4477 8 19V33C8 33.5523 8.44772 34 9 34H31C31.5523 34 32 33.5523 32 33V19C32 18.4477 31.5523 18 31 18H9Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Unlock;
